import { UpdateReceiptInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateReceiptInputSchema: z.ZodType<UpdateReceiptInput> = z.object(
  {
    receipt: z.instanceof(File).optional(),
    remove_receipt: z.boolean().optional(),
  },
);
